import { RecurrencePattern } from "./task";
export const touchpointKinds = ["email", "call", "text"];
export const cadenceUnits = [
    RecurrencePattern.Daily,
    RecurrencePattern.Weekly,
    RecurrencePattern.Monthly,
];
//# sourceMappingURL=touchpoint.js.map